import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDragSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <circle
      cx={7.733}
      cy={5.333}
      r={1.333}
      transform="rotate(90 7.733 5.333)"
    />
    <circle
      cx={12.178}
      cy={5.333}
      r={1.333}
      transform="rotate(90 12.178 5.333)"
    />
    <circle
      cx={7.733}
      cy={9.778}
      r={1.333}
      transform="rotate(90 7.733 9.778)"
    />
    <circle
      cx={12.178}
      cy={9.778}
      r={1.333}
      transform="rotate(90 12.178 9.778)"
    />
    <circle
      cx={7.733}
      cy={14.222}
      r={1.333}
      transform="rotate(90 7.733 14.222)"
    />
    <circle
      cx={12.178}
      cy={14.222}
      r={1.333}
      transform="rotate(90 12.178 14.222)"
    />
  </svg>
);
export default SvgDragSmall;
